<template>
    <div class="the-content">
        <v-container>
            <slot/>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "TheContent"
    }
</script>

<style lang="scss">
    
    // content
    .the-content {
        padding-top: 30px;
        padding-bottom: 50px;
        
        .p-heading {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 30px;
    
            .p-heading__ttl {
                padding-top: 2px;
                padding-bottom: 2px;
            }
    
            .p-heading__btn {
                margin-left: 20px;
            }
        }
    }
    
    // heading
    .heading {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        
        &.flex-xs-block {
            .viewport-xs & {
                display: block;
            }
        }
        
        
        .heading-nav {
            margin-right: 20px;
        }
        
    
        .heading-title {
            margin: 0 auto 0 0;
            line-height: 1.2;
        }
        
        
        .heading-buttons {
            margin-left: 20px;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
        }
    
        .heading-buttons__item {
            + .heading-buttons__item {
                margin-left: 16px;
            }
        }
        
        .heading-controls {
            flex: auto;
            display: flex;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: flex-end;
            margin-left: 20px;
            margin-right: -10px;
    
            .viewport-xs & {
                margin: 20px 0 0;
            }
        }
    
        .heading-controls__item {
            flex: 1;
            max-width: 50%;
            padding: 0 10px;
    
            .viewport-sm & {
                max-width: none;
            }
            .viewport-xs & {
                padding: 0;
                max-width: none;
            }
        }
    }
</style>